module.exports = __webpack_public_path__ + "img/near_cyl75_axis0.82b1cf38.jpg";